import {
  CellStyleModule,
  CheckboxEditorModule,
  ClientSideRowModelModule,
  ColumnAutoSizeModule,
  CustomFilterModule,
  DateFilterModule,
  GridStateModule,
  ModuleRegistry,
  NumberEditorModule,
  NumberFilterModule,
  PaginationModule,
  provideGlobalGridOptions,
  QuickFilterModule,
  RowApiModule,
  RowAutoHeightModule,
  RowDragModule,
  RowSelectionModule,
  RowStyleModule,
  TextEditorModule,
  TextFilterModule,
  TooltipModule,
  themeQuartz,
  ValidationModule,
} from "ag-grid-community";
import {
  AggregationModule,
  CellSelectionModule,
  ColumnMenuModule,
  ColumnsToolPanelModule,
  ContextMenuModule,
  FiltersToolPanelModule,
  LicenseManager,
  MasterDetailModule,
  PivotModule,
  RichSelectModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  ServerSideRowModelModule,
  SetFilterModule,
  SideBarModule,
} from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";

const licenseKey =
  "VXNpbmdfdGhpc197QUdfR3JpZH1fRW50ZXJwcmlzZV9rZXlfe0FHLTA3Mzc0OH1faW5fZXhjZXNzX29mX3RoZV9saWNlbmNlX2dyYW50ZWRfaXNfbm90X3Blcm1pdHRlZF9fX1BsZWFzZV9yZXBvcnRfbWlzdXNlX3RvX2xlZ2FsQGFnLWdyaWQuY29tX19fRm9yX2hlbHBfd2l0aF9jaGFuZ2luZ190aGlzX2tleV9wbGVhc2VfY29udGFjdF9pbmZvQGFnLWdyaWQuY29tX19fe0dhbW1hX1BlYWtfTExDfV9pc19ncmFudGVkX2Ffe1NpbmdsZV9BcHBsaWNhdGlvbn1fRGV2ZWxvcGVyX0xpY2Vuc2VfZm9yX3RoZV9hcHBsaWNhdGlvbl97Ymxpc31fb25seV9mb3JfezF9X0Zyb250LUVuZF9KYXZhU2NyaXB0X2RldmVsb3Blcl9fX0FsbF9Gcm9udC1FbmRfSmF2YVNjcmlwdF9kZXZlbG9wZXJzX3dvcmtpbmdfb25fe2JsaXN9X25lZWRfdG9fYmVfbGljZW5zZWRfX197Ymxpc31faGFzX2JlZW5fZ3JhbnRlZF9hX0RlcGxveW1lbnRfTGljZW5zZV9BZGQtb25fZm9yX3sxfV9Qcm9kdWN0aW9uX0Vudmlyb25tZW50X19fVGhpc19rZXlfd29ya3Nfd2l0aF97QUdfR3JpZH1fRW50ZXJwcmlzZV92ZXJzaW9uc19yZWxlYXNlZF9iZWZvcmVfezE4X0ZlYnJ1YXJ5XzIwMjZ9X19fX1t2M11fWzAxXV9NVGMzTVRNM01qZ3dNREF3TUE9PTY5MjE0NGUyZTA5NzY3MjRkMzFlNmMxNjg0MDBiNWFm";

LicenseManager.setLicenseKey(atob(licenseKey));

ModuleRegistry.registerModules([
  // Community — Row Models
  ClientSideRowModelModule,
  GridStateModule,

  // Community — Filters
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  CustomFilterModule,
  QuickFilterModule,

  // Community — Editors
  TextEditorModule,
  NumberEditorModule,
  CheckboxEditorModule,

  // Community — Features
  PaginationModule,
  RowApiModule,
  RowDragModule,
  RowSelectionModule,
  RowStyleModule,
  CellStyleModule,
  ColumnAutoSizeModule,
  TooltipModule,
  RowAutoHeightModule,

  // Enterprise — Row Models
  ServerSideRowModelModule,

  // Enterprise — Grouping & Aggregation
  RowGroupingModule,
  RowGroupingPanelModule,
  AggregationModule,
  PivotModule,

  // Enterprise — Features
  MasterDetailModule,
  SetFilterModule,
  RichSelectModule,
  CellSelectionModule,
  SideBarModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  ColumnMenuModule,
  ContextMenuModule,

  // Dev only — validation warnings for missing modules
  ...(import.meta.env.DEV ? [ValidationModule] : []),
]);

/** Quartz maps active filter icons to accent; shadcn `--accent` is a near-white fill, so override to readable tokens. */
const blisQuartzTheme = themeQuartz.withParams({
  iconButtonActiveColor: "var(--foreground)",
  iconButtonActiveIndicatorColor: "var(--ring)",
  iconButtonActiveBackgroundColor:
    "color-mix(in oklch, var(--foreground) 14%, transparent)",
});

provideGlobalGridOptions({
  theme: blisQuartzTheme,
});

export { AgGridReact, blisQuartzTheme };
